import { Routes, Route } from 'react-router-dom'
import { connect } from 'react-redux';
import { useEffect } from 'react';

import PageNotFound from '../PageNotFound.js'
import Home from './Home.js'
import MissionDetails from './MissionDetails.js';
import Login from './Login.js';

function App(props) {





    return (
      <div className="root" style={{}}>
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/home" element={<Login />} />
            <Route path="/missions" element={<Home />} />
            <Route path="/missions/:id" element={<MissionDetails />} />

            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );


}

export default connect((store) => {
  return {
    token: store.tokenReducer,
    control: store.controlReducer,
  }
})(App)